import { api } from '../utils/apiClient';

export const attributionLinkService = {
  async getAll(params) {
    return api.getWithMeta('/attribution/links', params);
  },

  async getById(id) {
    return api.get('/attribution/links/' + id);
  },

  async create(link) {
    return api.post('/attribution/links', link);
  },

  async update(id, patch) {
    return api.put('/attribution/links/' + id, patch);
  },

  async remove(id) {
    return api.del('/attribution/links/' + id);
  },

  async getAnalytics(range) {
    return api.get('/attribution/analytics', range);
  },

  async getClickStats(id, range) {
    return api.get('/attribution/links/' + id + '/clicks', range);
  },
};
